import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const EditRoleModal = ({
  open,
  handleClose,
  editLoading,
  onEdit,
  roleEditInfo,
}) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: { title: '', display: '' },
  });

  useEffect(() => {
    if (open && roleEditInfo) {
      reset({
        title: roleEditInfo?.name ?? roleEditInfo?.title ?? '',
        display: roleEditInfo?.display ?? '',
      });
    }
  }, [open, roleEditInfo, reset]);

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ویرایش نقش</DialogTitle>

      <DialogContent>
        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              autoFocus
              dir="ltr"
              label="عنوان سیستمی"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('title', { required: 'عنوان سیستمی الزامی است' })}
              error={isSubmitted ? !!errors.title : null}
              helperText={errors.title?.message}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              label="عنوان نمایشی"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('display', {
                required: 'عنوان نمایشی الزامی است',
              })}
              error={isSubmitted ? !!errors.display : null}
              helperText={isSubmitted ? errors.display?.message : null}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={editLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit(onEdit)}
          loading={editLoading}
          color="warning"
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export { EditRoleModal };

const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
